var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScrewPress = function SvgScrewPress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 17.4v3.2h16v-3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 17.4v3.2h16v-3.2zM14 15l3-4H8l3 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 13h3v5h-3z"
  })));
};
export { SvgScrewPress as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M8 17.3999L8 20.5999L24 20.5999V17.3999L8 17.3999Z' fill='%234A6067'/%3e %3cpath d='M8 17.3999L8 20.5999L24 20.5999V17.3999L8 17.3999Z' fill='%234A6067'/%3e %3cpath d='M14 15L17 11H8L11 15H14Z' fill='%234A6067'/%3e %3crect x='11' y='13' width='3' height='5' fill='%234A6067'/%3e %3c/svg%3e";